export const CARD_BRAND_ICONS: Record<string, string> = {
  visa: "/icons/visa.svg",
  mastercard: "/icons/mastercard.svg",
  american_express: "/icons/american-express.svg",
  discover: "/icons/discover.svg",
};
